var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"textblock d-flex justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"small_separator"}),_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }